import { createSectionForm } from "./sectionFormKit";

// Customer: components/sections/YoutubeVideo/YoutubeVideo.js
const YoutubeVideo = createSectionForm({
  icon: "youtube-line",
  title: "YouTube Video",
  fields: [
    { name: "title", label: "Video Title", placeholder: "About Us" },
    { name: "video_url", label: "YouTube Video", type: "video", fullWidth: true },
  ],
});

export default YoutubeVideo;
